/** The available wireframe UX variants for the medical questionnaire step. */
enum MedicalUxVersion {
  CombinedPage = "medicalUxVersion.combinedPage"
}

export default MedicalUxVersion;
